import {
  setAlternativePhoneOne,
  setCreatedEmail,
  setEnquiryStep,
  setDescription,
  setEventDetails,
  setFullName,
  setNoOtherVendors,
  setOtherVendors,
  setPhone,
  setZipcode,
} from "../../../redux/slices/InquirySlice";

export const PopulateInquiry = (enquiryData, dispatch) => {
  if (enquiryData) {
    dispatch(setEnquiryStep(enquiryData.enquiryStep));
    dispatch(setFullName(enquiryData.FullName));
    dispatch(setCreatedEmail(enquiryData.Email));
    dispatch(setZipcode(enquiryData.Zipcode));
    dispatch(setDescription(enquiryData.Description));
    dispatch(setPhone(enquiryData.Phone));
    dispatch(setAlternativePhoneOne(enquiryData.alternativePhoneOne));
    dispatch(setEventDetails(enquiryData.eventDetails));
    dispatch(setOtherVendors(enquiryData.otherVendors));
    if (enquiryData.otherVendors.length === 0) {
      dispatch(setNoOtherVendors(1));
    }
  }
};
